
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    url?: string;
}

const SEO: React.FC<SEOProps> = ({
    title = "Nuviosites | TDMA - Digital Marketing, SEO & Web Development Agency",
    description = "Nuviosites | TDMA offers cutting-edge digital marketing, SEO, web development, and AI solutions to help businesses grow. Transform your digital presence today.",
    keywords = "Nuviosites, TDMA, digital marketing, SEO, web development, AI solutions, custom websites, business growth",
    image = "/favicon_io/android-chrome-512x512.png",
    url = "https://tdma.one"
}) => {
    // If title is already optimized or contains "Nuviosites | TDMA", use it as is.
    // Otherwise, append "| Nuviosites | TDMA"
    const siteTitle = title.includes("Nuviosites | TDMA") ? title : `${title} | Nuviosites | TDMA`;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{siteTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={siteTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;
